export const faqs = [
  {
    id: 1,
    category: "Orders & Shipping",
    question: "How long does shipping take?",
    answer: "Standard shipping typically takes 3-5 business days within the continental US. Express shipping (1-2 business days) and overnight shipping options are also available at checkout. International shipping times vary by destination, usually 7-14 business days."
  },
  {
    id: 2,
    category: "Orders & Shipping",
    question: "Do you offer free shipping?",
    answer: "Yes! We offer free standard shipping on all orders over $50 within the US. For orders under $50, a flat rate of $7.99 applies. Free shipping promotions may vary for international orders."
  },
  {
    id: 3,
    category: "Orders & Shipping",
    question: "Can I track my order?",
    answer: "Absolutely! Once your order ships, you'll receive a tracking number via email. You can use this number to track your package in real-time through our website or the carrier's tracking portal."
  },
  {
    id: 4,
    category: "Returns & Refunds",
    question: "What is your return policy?",
    answer: "We offer a 30-day return policy on most items. Products must be in original condition with all packaging and accessories. Gaming consoles and computers must be unopened unless defective. Contact our support team to initiate a return."
  },
  {
    id: 5,
    category: "Returns & Refunds",
    question: "How do I get a refund?",
    answer: "Once we receive and inspect your returned item, we'll process your refund within 5-7 business days. Refunds are issued to the original payment method. Shipping costs are non-refundable unless the return is due to our error."
  },
  {
    id: 6,
    category: "Products & Warranty",
    question: "Are all products brand new?",
    answer: "Yes, all products sold on our website are 100% authentic and brand new, unless specifically marked as refurbished. We source directly from manufacturers and authorized distributors to ensure quality."
  },
  {
    id: 7,
    category: "Products & Warranty",
    question: "Do products come with warranty?",
    answer: "All products include the manufacturer's standard warranty. Gaming consoles typically have 1-year warranties, while computers and laptops may have 1-3 year warranties depending on the brand. Extended warranty options are available at checkout."
  },
  {
    id: 8,
    category: "Products & Warranty",
    question: "Can I pre-order upcoming releases?",
    answer: "Yes! We offer pre-orders for highly anticipated gaming consoles, graphics cards, and other electronics. Pre-orders are charged at the time of purchase, and items ship on or shortly after the official release date."
  },
  {
    id: 9,
    category: "Payment & Security",
    question: "What payment methods do you accept?",
    answer: "We accept all major credit cards (Visa, Mastercard, American Express, Discover), PayPal, Apple Pay, Google Pay, and Shop Pay. All transactions are secured with 256-bit SSL encryption."
  },
  {
    id: 10,
    category: "Payment & Security",
    question: "Is my payment information secure?",
    answer: "Absolutely. We use industry-standard encryption and never store your complete credit card information on our servers. All payment processing is handled through secure, PCI-compliant payment gateways."
  },
  {
    id: 11,
    category: "Technical Support",
    question: "Do you provide technical support?",
    answer: "Yes! Our technical support team is available Monday-Friday, 9 AM - 6 PM EST. We can help with product setup, troubleshooting, and general questions. Contact us via email, phone, or live chat."
  },
  {
    id: 12,
    category: "Technical Support",
    question: "What if my product arrives damaged?",
    answer: "If your product arrives damaged or defective, please contact us within 48 hours of delivery with photos of the damage. We'll arrange for a replacement or full refund, including return shipping costs."
  }
];
